import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useFormContext } from "react-hook-form";

const SGID_PATH = "tiptap_body.sgids_to_object_map";
const ATTACHMENTS_PATH = "tiptap_body.inline_attachments";

export const useTiptapBodyHandlers = () => {
  const { watch, setValue, getValues } = useFormContext<PostFormValues>();
  const sgidToObjectMap: Record<string, unknown> = watch(SGID_PATH) || {};
  const inlineAttachments: unknown[] = watch(ATTACHMENTS_PATH) || [];

  const handleSgidChange = (next: Record<string, unknown>) => {
    const current = getValues(SGID_PATH) ?? {};
    setValue(SGID_PATH, { ...current, ...next }, { shouldDirty: true });
  };

  const handleAttachmentsChange = (next: unknown[]) => {
    const current = getValues(ATTACHMENTS_PATH) ?? [];
    const attachments = Array.from(new Set([...current, ...next]));
    setValue(ATTACHMENTS_PATH, attachments, { shouldDirty: true });
  };

  return {
    handleAttachmentsChange,
    handleSgidChange,
    inlineAttachments,
    sgidToObjectMap,
  };
};
